"use strict";

exports.__esModule = true;
exports.capitalizeWords = capitalizeWords;
function capitalizeWords(words) {
  return words.map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(" ");
}